export const API_ERRORS = {
  SESSION_EXPIRED: 'Session Expired',
  INTERNAL_SERVER_ERROR: 'Internal Server Error',
  UNAUTHORIZED: 'Unauthorized',
  NOT_FOUND: 'Not Found',
};
